import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "w-full relative transform overflow-hidden text-left transition-all border border-gray-300 bg-white rounded-lg" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "flex justify-between border-b border-b-2 border-gray-200" }
const _hoisted_5 = { class: "text-lg text-gray-900 font-semibold p-6" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "w-full max-h-[30rem] overflow-y-scroll overflow-x-scroll" }
const _hoisted_8 = {
  id: "bulk-preview-table",
  class: "table-fixed min-w-full divide-y divide-gray-300 whitespace-nowrap"
}
const _hoisted_9 = { class: "rounded-lg" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { class: "text-start text-xs text-gray-600 font-medium py-3 pl-6" }, null, -1)
const _hoisted_11 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-start text-xs text-gray-600 font-medium py-3"
}
const _hoisted_13 = { class: "text-start text-xs text-[#475467] font-medium py-3 pr-2" }
const _hoisted_14 = { class: "text-start text-xs text-gray-600 font-medium py-3 pr-2" }
const _hoisted_15 = { class: "text-start text-xs text-gray-600 font-medium py-3 pr-2" }
const _hoisted_16 = { class: "text-start text-xs text-gray-600 font-medium py-3 pr-2" }
const _hoisted_17 = {
  key: 1,
  class: "text-start text-xs text-gray-600 font-medium py-3 pr-2"
}
const _hoisted_18 = {
  key: 2,
  class: "text-start text-xs text-gray-600 font-medium py-3 pr-2"
}
const _hoisted_19 = {
  key: 4,
  class: "text-start text-xs text-[#475467] font-medium py-3 pr-2"
}
const _hoisted_20 = {
  key: 5,
  class: "text-start text-xs text-[#475467] font-medium py-3 pr-2"
}
const _hoisted_21 = { class: "divide-y divide-gray-200" }
const _hoisted_22 = { class: "text-sm text-gray-600 py-6 text-left pl-6" }
const _hoisted_23 = { class: "text-sm text-gray-500 py-6 text-left" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-[#667085] py-6 text-left"
}
const _hoisted_25 = { class: "text-sm text-gray-900 font-medium py-6 text-left" }
const _hoisted_26 = { class: "text-sm text-gray-900 font-medium py-6 text-left" }
const _hoisted_27 = { class: "text-sm text-gray-600 py-6 text-left" }
const _hoisted_28 = { class: "text-sm text-gray-600 py-6 text-left" }
const _hoisted_29 = {
  key: 1,
  class: "text-sm text-gray-600 py-6 text-left pr-2"
}
const _hoisted_30 = {
  key: 2,
  class: "w-auto text-sm text-gray-600 py-6 text-left pr-2"
}
const _hoisted_31 = {
  key: 4,
  class: "text-sm text-[#475467] py-2 text-left"
}
const _hoisted_32 = {
  key: 5,
  class: "text-sm text-[#475467] py-2 text-left"
}
const _hoisted_33 = {
  key: 0,
  class: "w-full rounded-md bg-red-50 p-4"
}
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "shrink-0" }
const _hoisted_36 = { class: "ml-3 flex-1 md:flex md:items-center md:justify-between" }
const _hoisted_37 = {
  key: 0,
  class: "ml-3 flex-1 md:flex md:items-center md:justify-between"
}
const _hoisted_38 = { class: "text-sm text-red-700" }
const _hoisted_39 = { class: "mt-3 text-sm md:ml-6 md:mt-0" }
const _hoisted_40 = {
  key: 1,
  class: "text-sm text-red-700"
}
const _hoisted_41 = { class: "w-full flex justify-between items-center px-8 py-6" }
const _hoisted_42 = { class: "" }
const _hoisted_43 = { class: "flex items-center" }

import { computed, ref, watch, onMounted } from "vue";
import { FormKitNode } from "@formkit/core";
import { getValidationMessages } from "@formkit/validation";
import { useToast } from "primevue/usetoast";
import i18n from "@/plugins/i18n";
import {
  UserIcon,
} from "@heroicons/vue/24/outline";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewBulkUploadComponent',
  props: {
  uploadType: {
    type: String,
  },
  classId: {
    type: String,
  },
  className: {
    type: String,
  },
  grade: {
    type: Number,
  },
  subject: {
    type: String,
  },
  learnersToUpload: {
    type: Array,
    required: true,
  },
},
  emits: ["cancelPreview", "transmitFinalLearners", "previousStep", "resetState"],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast();

const notificationError = ref("");

const filterStore = useFilterStore();
const learnerStore = useLearnerStore();
const subjectStore = useSubjectStore();
const schoolStore = useSchoolStore();

// Define props that the component accepts


const learners = ref<any[]>([]);
const isSubmitting = ref(false);
const formErrors = ref<any>([]);
const duplicateEmails = ref<any>([]);

watch(
  () => props.learnersToUpload,
  (newVal) => {
    //check for duplicates in uploaded list
    duplicateEmails.value = newVal
      .map((learner: any) => learner.email)
      .filter((email, index, self) => self.indexOf(email) !== index);
    //collect learners
    learners.value = newVal.map((learner: any) => ({
      ...learner,
    }));
  },
  { immediate: true }
);

const allSubjects = computed(() => {
  const allSubjects = filterStore.selectedSchool.classes.map((classGroup) => classGroup.subject);
  const uniqueSubjects = [...new Set(allSubjects)];
  return uniqueSubjects;
});

const subjectName = (subjectId: string) => {
  const subject = subjectStore.subjects.find((s) => s.id == subjectId);

  return subject ? subject.name : "unknown";
};

const allClassGroupsByGradeAndSubject = (grade: number, subjectId: string) => {
  let options = filterStore.selectedSchool.classes
    .filter((classGroup) =>
      classGroup.subject === subjectId && 
      classGroup.gradeLevel == grade
    ) 
    .map((classGroup) => ({
      label: classGroup.name,
      value: classGroup._id,
    }));
  options.unshift({ value: "", label: "Select" });
  return options;
};

const allSchoolGrades = computed(() => {
  return filterStore.selectedSchool.grades.map((grade) => ({
    label: grade,
    value: grade,
  }));
});

// seeting the locked journeys boolenas based on data recieved
learners.value.forEach(learner => {
  if (learner.lockedJourneys === null) {
    delete learner.lockedJourneys;
  }

  // console.log("HAVE A LOOK HERE: ", learner);

  if (learner.lockedJourneys === "catchup" || learner.lockedJourneys === "Catchup") {
    learner.lockedJourneys = {
      catchup: true,
      assessment: false
    };
  } else if (learner.lockedJourneys === "assessment" || learner.lockedJourneys === "Assessment") {
    learner.lockedJourneys = {
      catchup: false,
      assessment: true
    };
  } else if (learner.lockedJourneys === "none" || learner.lockedJourneys === "None") {
    learner.lockedJourneys = {
      catchup: false,
      assessment: false
    };
  } else if (learner.lockedJourneys === "" || learner.lockedJourneys === null) {
    delete learner.lockedJourneys;
  }

  // console.log("HAVE A LOOK HERE AFTER: ", learner);
});

// Function to handle form submission when the form is valid
const onFormSubmit = async (formData: any) => {
  isSubmitting.value = true;
  try {
    if (props.uploadType === "grade") {
      // Transform selectedClasses into an array for each learner
      learners.value.forEach((learner) => {
        const selectedClassIds = Object.values(learner.selectedClasses).filter(
          (id) => id
        );
        learner.selectedClasses = selectedClassIds;
        // Remove the grade property from learner
        delete learner.grade;
      });
    } else if (props.uploadType === "class") {
      // For 'class' uploadType, set selectedClasses to be an array with the classId prop
      learners.value.forEach((learner) => {
        learner.selectedClasses = [props.classId];
        delete learner.grade;
      });

    }

    // Emit the learners to upload
    emit("transmitFinalLearners", learners.value);


    // Clear the preview learners
    clearPreviewLearners();
  } catch (error) {
    console.error("Error submitting learners:", error);
  } finally {
    isSubmitting.value = false;
  }
};

// Function to handle form submission when the form is invalid
const onFormInvalid = (node: any) => {
  const validations = getValidationMessages(node);

  validations.forEach((inputMessages) => {
    formErrors.value = formErrors.value.concat(
      inputMessages.map((message) => message.value)
    );
  });
  // Optionally, you can display a notification or highlight errors
  console.warn("Form submission failed due to validation errors:", validations);
};

const clearPreviewLearners = () => {
  // Clearing the uploaded learners and resetting the UI state
  learners.value = [];
  formErrors.value = [];
};

const previousStep = () => {
  emit("previousStep");
};

const cancelPreview = () => {
  
  emit("cancelPreview");
};

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await learnerStore.validateEmail(node.value as string);

    return !emailExists;
  } catch (error) {
    notificationError.value = "exists";
    return true;
  }
};

const duplicate_email_in_list = (node: FormKitNode): boolean => {
  const isDuplicate = duplicateEmails.value.includes(node.value);
  return !isDuplicate;
};

// Set up watchers for each learner and subject
learners.value.forEach((learner) => {
  allSubjects.value.forEach((subjectId) => {
    //grade change to reset selected classes
    watch(
      () => learner.grade,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          learner.selectedClasses[subjectId] = "";
        }
      }
    );
  });
});

const localeOptions = [
  { label: "en-ZA", value: "en-ZA" },
  { label: "en-GB", value: "en-GB" },
  { label: "en-AU", value: "en-AU" },
  { label: "af-ZA", value: "af-ZA" },
  { label: "sv-SE", value: "sv-SE" },
  { label: "es-PE", value: "es-PE" }
];

const learningModeOptions = computed(() =>
  schoolStore.getLearningModes.map(mode => ({
    label: mode.label,
    value: mode.value
  }))
);

onMounted(() => {

  // Reset the modal state when the component is mounted
  emit("resetState");

});

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    type: "form",
    actions: false,
    ref: "learnersForm",
    onSubmit: onFormSubmit,
    onSubmitInvalid: onFormInvalid,
    "validation-errors": formErrors.value,
    classes: {
      message: 'hidden text-red-500 text-xs px-8 pb-6',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t(
                  "bulk_learner_upload_component.generate_emails_modal.file_upload_header",
                  {
                    uploadType:
                      props.uploadType == "grade"
                        ? _ctx.$t(
                            "bulk_learner_upload_component.generate_emails_modal.grade_label"
                          )
                        : _ctx.$t(
                            "bulk_learner_upload_component.generate_emails_modal.class_label"
                          ),
                  }
                )) + " " + _toDisplayString(props.uploadType == "grade" ? '' : props.className), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Toast, {
                  position: "bottom-right",
                  group: "br"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.email"
                      )), 1),
                    (props.uploadType === 'grade' && learners.value.some(learner => learner.newEmail))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.new_email"
                      )), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.first_name"
                      )), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.last_name"
                      )), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.student_number"
                      )), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.password"
                      )), 1),
                    (props.uploadType === 'grade' && learners.value.some(learner => learner.assessmentType))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_17, _toDisplayString(_ctx.$t(
                      "bulk_learner_upload_component.preview_learners.assessment"
                    )), 1))
                      : _createCommentVNode("", true),
                    (props.uploadType === 'grade')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_18, _toDisplayString(_ctx.$t(
                      "bulk_learner_upload_component.preview_learners.grade"
                    )), 1))
                      : _createCommentVNode("", true),
                    (props.uploadType === 'grade')
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(allSubjects.value, (subjectId) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: subjectId,
                            class: "text-start text-xs text-gray-600 font-medium py-3"
                          }, _toDisplayString(subjectName(subjectId)) + " " + _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.class"
                        )), 1))
                        }), 128))
                      : _createCommentVNode("", true),
                    (props.uploadType === 'grade' && learners.value.some(learner => learner.preferredLanguage))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.locale"
                      )), 1))
                      : _createCommentVNode("", true),
                    (props.uploadType === 'grade' && learners.value.some(learner => learner.learningMode))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_20, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.learningMode"
                      )), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learners.value, (learner, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "rounded-lg",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_22, [
                        _createVNode(_unref(UserIcon), { class: "w-5 h-5 text-gray-500" })
                      ]),
                      _createElementVNode("td", _hoisted_23, [
                        _createVNode(_component_FormKit, {
                          id: learner.email,
                          type: "text",
                          modelValue: learner.email,
                          "onUpdate:modelValue": ($event: any) => ((learner.email) = $event),
                          placeholder: "Learner Email",
                          classes: {
                        outer: '',
                        wrapper: 'w-11/12',
                        message: 'text-red-500 text-xs px-3',
                        input:
                          'w-40 text-gray-600 text-sm border-none py-2 h-10 rounded-lg focus:outline-none',
                      },
                          validation: "required|email_exists|email|duplicate_email_in_list",
                          "validation-rules": {
                        email_exists: email_exists,
                        duplicate_email_in_list: duplicate_email_in_list
                      },
                          "validation-visibility": "submit",
                          "validation-messages": {
                        email_exists: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_validation'
                        ),
                        email: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_invalid'
                        ),
                        duplicate_email_in_list: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_duplicate'
                        )
                      }
                        }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                      ]),
                      (props.uploadType === 'grade' && learner.newEmail)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                            _createVNode(_component_FormKit, {
                              id: learner.newEmail,
                              type: "text",
                              modelValue: learner.newEmail,
                              "onUpdate:modelValue": ($event: any) => ((learner.newEmail) = $event),
                              placeholder: "U Email",
                              classes: {
                        outer: '',
                        wrapper: 'w-11/12',
                        message: 'text-red-500 text-xs px-3',
                        input:
                          'w-40 text-gray-600 text-sm border-none py-2 h-10 rounded-lg focus:outline-none',
                      },
                              validation: "required|email_exists|email|duplicate_email_in_list",
                              "validation-rules": {
                        email_exists: email_exists,
                        duplicate_email_in_list: duplicate_email_in_list
                      },
                              "validation-visibility": "submit",
                              "validation-messages": {
                        email_exists: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_validation'
                        ),
                        email: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_invalid'
                        ),
                        duplicate_email_in_list: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_duplicate'
                        )
                      }
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(learner.firstName), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(learner.lastName), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(learner.studentNumber), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString("•".repeat(learner.password.length)), 1),
                      (props.uploadType === 'grade' && learner.assessmentType)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(learner.assessmentType.replaceAll('_', ' ')), 1))
                        : _createCommentVNode("", true),
                      (props.uploadType === 'grade')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              modelValue: learner.grade,
                              "onUpdate:modelValue": ($event: any) => ((learner.grade) = $event),
                              options: allSchoolGrades.value,
                              placeholder: `Select Grade`,
                              classes: {
                        input:
                          'text-gray-600 text-sm border border-gray-300 py-2 h-10 rounded-lg focus:outline-none',
                      }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      (props.uploadType === 'grade')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(allSubjects.value, (subjectId) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: subjectId,
                              class: "text-sm text-gray-600 py-6 text-left pr-6 mr-2"
                            }, [
                              _createVNode(_component_FormKit, {
                                type: "select",
                                modelValue: learner.selectedClasses[subjectId],
                                "onUpdate:modelValue": ($event: any) => ((learner.selectedClasses[subjectId]) = $event),
                                options: allClassGroupsByGradeAndSubject(learner.grade, subjectId),
                                placeholder: `Select`,
                                classes: {
                          input:
                            'text-gray-600 text-sm border border-gray-300 py-2 h-10 rounded-lg focus:outline-none',
                        }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ]))
                          }), 128))
                        : _createCommentVNode("", true),
                      (props.uploadType === 'grade')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                            (learner.preferredLanguage)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  type: "select",
                                  modelValue: learner.preferredLanguage,
                                  "onUpdate:modelValue": ($event: any) => ((learner.preferredLanguage) = $event),
                                  options: localeOptions,
                                  placeholder: _ctx.$t('bulk_learner_upload_component.preview_learners.table.locale'),
                                  classes: {
                        input: 'text-[#475467] text-sm border border-gray-300 py-2 h-10 rounded-lg focus:outline-none',
                      }
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (props.uploadType === 'grade')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                            (learner.learningMode)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  type: "select",
                                  modelValue: learner.learningMode,
                                  "onUpdate:modelValue": ($event: any) => ((learner.learningMode) = $event),
                                  options: learningModeOptions.value,
                                  placeholder: _ctx.$t('bulk_learner_upload_component.preview_learners.table.learningMode'),
                                  classes: {
                        input: 'text-[#475467] text-sm border border-gray-300 py-2 h-10 rounded-lg focus:outline-none',
                      }
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        (formErrors.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(InformationCircleIcon), {
                    class: "h-5 w-5 text-red-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_36, [
                  (!notificationError.value.includes('exists'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t(
                    "bulk_learner_upload_component.preview_learners.error_alert_title"
                  )), 1),
                        _createElementVNode("p", _hoisted_39, [
                          _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (onFormSubmit(null))),
                            class: "whitespace-nowrap font-medium text-red-700 hover:text-red-600 border-solid border border-red-800 rounded-full py-2 px-6"
                          }, _toDisplayString(_ctx.$t(
                      "bulk_learner_upload_component.preview_learners.error_alert_button_label"
                    )), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.$t(
                  "bulk_learner_upload_component.preview_learners.email_invalid"
                )), 1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              onClick: previousStep,
              type: "button",
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-small-back-arrow',
                title: 'rl small back arrow',
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_back")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              onClick: cancelPreview,
              type: "button",
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_cancel")), 1),
            _createVNode(_component_FormKit, {
              type: "submit",
              class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]",
              disabled: isSubmitting.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_submit")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-errors"]))
}
}

})